import './registerServiceWorker';
import 'animate.css';
import { createApp } from 'vue';
import Dialog from 'quasar/src/plugins/Dialog.js';import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';;
import App from './App.vue';
import axios from 'axios';
import axiosSetUp from './axios';
import CKEditor from '@ckeditor/ckeditor5-vue';
import i18n from './locales';
import moment from 'moment';
import quasarUserOptions from './quasar-user-options';
import router from './router';
import store from './store';
import VueAxios from 'vue-axios';
import SvgIcon from '@/components/SvgIcon';
//
import globalMixin from './globalMixin';

//
import { sharedMethod } from './utils/utils';


// load svg files
const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context('@/assets/icon', false, /\.svg$/);
requireAll(req);

axiosSetUp();

const app = createApp(App);

app.config.globalProperties.$moment = moment;
app.config.globalProperties.$validators = {
  email(value) {
    return /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/.test(value);
  },
};
app.config.globalProperties.$filters = {
  formatDate(val) {
    return moment(val).format('YYYY/MM/DD HH:mm:ss');
  },
  formatShortDate(val) {
    return moment(val).format('YYYY/MM/DD');
  },
};

app.config.globalProperties.$notify = Notify;
app.config.globalProperties.$dialog = Dialog;
//
app.config.globalProperties.$sharedMethod = sharedMethod;

app.use(Quasar, quasarUserOptions);
app.use(VueAxios, axios);
app.use(i18n);
app.use(CKEditor);
app.use(store);
app.use(router);
app.component('Icon', SvgIcon);

//
//app.mixin(globalMixin);
app.config.globalProperties.$onAndroidLogout = globalMixin.methods.onAndroidLogout;
app.config.globalProperties.$getAndroidLanguege = globalMixin.methods.getAndroidLanguege;
app.config.globalProperties.$setAndroidLanguege = globalMixin.methods.setAndroidLanguege;
window.onAndroidLogout = globalMixin.methods.onAndroidLogout;
window.getAndroidLanguege = globalMixin.methods.getAndroidLanguege;
window.setAndroidLanguege = globalMixin.methods.setAndroidLanguege;

app.mount('#app');